import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialFederalDebtModel } from './types';
import { pvqFinancialFederalDebtItemValidator } from './validators/item';

const financialFederalDebtValidator: ValidateJSModel<FinancialFederalDebtModel> = {
  HasFailedToFile: {
    hasValue: { validator: hasYesOrNo },
  },

  FailedToFileList: (value, attributes) => {
    if (attributes?.HasFailedToFile?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialFederalDebtItemValidator('FAILED_TO_FILE') },
      };
    }

    return {};
  },

  HasFailedToPay: {
    hasValue: { validator: hasYesOrNo },
  },

  FailedToPayList: (value, attributes) => {
    if (attributes?.HasFailedToPay?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialFederalDebtItemValidator('FAILED_TO_PAY') },
      };
    }

    return {};
  },

  HasOther: {
    hasValue: { validator: hasYesOrNo },
  },

  OtherList: (value, attributes) => {
    if (attributes?.HasOther?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialFederalDebtItemValidator('OTHER') },
      };
    }

    return {};
  },
};

export default financialFederalDebtValidator;
